/* eslint-disable react/no-unescaped-entities */
import DocPageLayout, { Section } from "@/components/DocPageLayout";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <DocPageLayout
      subtitle="Origin"
      title="About Hunt57"
      intro="Hunt57 is a private, invite-only marketplace for sports card collectors. Zero selling fees, no monetary handling, real reputations. Built for hobbyists, by hobbyists."
    >
      <Section title="Why we built it">
        <p>The card hobby has a scammer problem. Open marketplaces attract bad actors — fake grades, shill bidding, ghosted shipments. Bigger platforms take 12-15% out of every sale. Neither is great for the people who actually love the cards.</p>
        <p>Hunt57 is invite-only so every member is vouched for. Sales go directly buyer-to-seller through the payment method the seller already uses. The platform earns via a modest vendor subscription — nothing else. No selling fees. No cut. No middleman friction.</p>
      </Section>

      <Section title="What Hunt57 is">
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>A private community-first listing service for cards.</li>
          <li>A reputation layer — every completed sale + feedback builds a public track record.</li>
          <li>A discovery engine — filters, seller typeahead, featured strips, watchlists, likes.</li>
          <li>A messaging channel with FIRM-listing enforcement and abuse reporting.</li>
        </ul>
      </Section>

      <Section title="What Hunt57 is not">
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>An escrow service. We do not hold money.</li>
          <li>A payment processor. Sellers get paid directly.</li>
          <li>A dispute arbiter for transactions. Chargebacks and refunds are between you and your payment provider.</li>
          <li>An authenticator or grader. Verify cards through the appropriate services (PSA, SGC, BGS).</li>
        </ul>
        <p className="mt-2">See the <Link to="/terms" className="text-[#FF5F1F] underline">Terms</Link> for the legal specifics.</p>
      </Section>

      <Section title="Who runs it">
        <p>Hunt57 is a service of <strong className="text-white">Breaking Legends, LLC</strong>, powered by <a href="https://lab21g.com" target="_blank" rel="noopener noreferrer" className="text-[#FF5F1F] underline">LAB21G.com</a>. Day-to-day operations are handled by a small team of admins recruited from the hobby.</p>
        <p>Questions about the company or partnerships? Use the <Link to="/contact" className="text-[#FF5F1F] underline">Contact</Link> form with category "Other" and we'll route it.</p>
      </Section>

      <Section title="How to join">
        <p>Anyone can create a free buyer account at <Link to="/register" className="text-[#FF5F1F] underline">/register</Link>. To sell, you either apply for admin review or redeem a referral code from an existing Tier 3 vendor. See the <Link to="/how-to#become-vendor" className="text-[#FF5F1F] underline">How To</Link> and <Link to="/vendor-handbook" className="text-[#FF5F1F] underline">Vendor Handbook</Link> for the full walkthrough.</p>
      </Section>
    </DocPageLayout>
  );
}
